import styled, { css, keyframes } from "styled-components";
import { darken } from "polished";

import { ICardProps } from "./interfaces";

export const Card = styled.div<ICardProps>`
    background-color: ${p => p.tiny ? p.theme.c.whiteOnActive : p.theme.c.cardBackground};
    box-shadow: 0 0 4px 0 ${p => p.theme.c.blackShadow3};
    ${p =>
        p.extra &&
        css`
            background-color: ${p => darken(0.03, p.theme.c.light)};
            box-shadow: 0 0 4px 0 ${p => p.theme.c.blackShadow3}, rgba(0, 150, 140, 0.4) 0 0 0 1px inset;
        `}
    ${p =>
        p.christmas &&
        css`
            background-color: white;
        `}
    border-radius: 8px;
    position: relative;
    min-width: 0;
    transition: 300ms;
    z-index: 6;
    ${p =>
        p.tiny
            ? css`
                  border: 2px solid rgba(0, 0, 0, 0.1) !important;
            `
            : undefined}

    .Image {
        background-size: 100%;
        position: relative;
        background-position: center center;
        transition: background 450ms;
        display: grid;
        background-repeat: no-repeat;
        ${p =>
        p.tiny
            ? css`
                        border-radius: 6px;
                    `
            : undefined}

    }

    transform-style: flat;

    ${p =>
        !p.play
            ? css`
                  &:hover {
                      z-index: 10;
                      box-shadow: 0 0 10px 0 ${p => p.theme.c.blackShadow5};
                      transform: scale(0.984) translateZ(0);
                      .Image {
                          ${!p.tiny
                    ? css`
                                    background-size: 104%;
                                `
                    : undefined}
                      }
                  }
              `
            : undefined}
    ${p =>
        p.disabled
            ? css`
                  pointer-events: none;
                  opacity: 0.7;
              `
            : undefined}
`;

const Loading = keyframes`
    0% {
        background-position: -100px 0
    }
    100% {
        background-position: 300px 0
    }
`;

export const LoaderTop = styled.div`
    height: 21px;
    margin: 11px;
    margin-right: 60px;
    background: linear-gradient(90deg, #d2d2d2 7%, #f0f0f0 28%, #d2d2d2 50%);
    background-size: 400px;
    animation: ${Loading} 0.8s infinite forwards linear;
`;

export const LoaderBottom = styled.div`
    height: 21px;
    margin: 15px 11px;
    text-align: center;
    background: linear-gradient(90deg, #d2d2d2 7%, #f0f0f0 28%, #d2d2d2 50%);
    background-size: 400px;
    animation: ${Loading} 2s infinite forwards linear;
`;

export const Gap = styled.div`
    width: 40px;
    background: ${p => p.theme.c.cardBackground};
    height: 21px;
    display: inline-block;
    margin-left: 40px;
`;
